module.exports = __webpack_public_path__ + "static/media/calcIconBlue.440f8036.svg";